import { getCookie, loadScript } from '@/resources/utils'

export const SprinklrChatWidget = (
  { id, address = {}, name = '', document: pocDocument = '' },
  { chatHashCode = '' }
) => {
  const { city, provinceCode } = address

  const widgetUrl = `${process.env.SPRINKLR_URL}/${process.env.SPRINKLR_APP_ID}`

  window.sprChatSettings = {
    appId: process.env.SPRINKLR_APP_ID,
    user: {
      id,
      firstName: name,
      email: getCookie('email'),
      hash: chatHashCode,
    },
    userContext: {
      _c_61a4f59dc20c1b0f284b6548: [provinceCode],
      _c_618c08db3c19bf52c790143a: [name],
      _c_61a8f906be6f0838973dc8bf: [id],
      _c_618c099a52ea144d240e67aa: [city],
      _c_61a4f4f3c20c1b0f284aebbc: [pocDocument],
    },
  }

  loadScript({ src: widgetUrl, onHead: true, defer: true })
}
